import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import ScrollToHash from "./ScrollToHash";
import ErrorBoundary from "designs/Common/ErrorBoundary";
import Footer from "designs/DesignA/components/Footer/Footer";
import Page404 from "designs/DesignA/containers/Page404/Page404";
import ListingCarPage from "designs/DesignA/containers/ListingCarPage/ListingCarPage";

import PageContact from "designs/DesignA/containers/PageContact/PageContact";
import SiteHeader from "designs/DesignA/containers/SiteHeader";
import MainNav from "designs/DesignA/components/Header/MainNav";
import PinnedHeader from "designs/Common/TopBarSearch/PinnedHeader";
import PageHome from "designs/DesignA/containers/PageHome/PageHome";
import AvailableCarsPage from "designs/DesignA/containers/AvailableCarsPage/AvailableCarsPage";
import ListingCarDetailPage from "designs/Common/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import CarListingCarDetailPage from "designs/Common/CarListingDetailPage/CarListingDetailPage";
import CheckOutPagePageMain from "designs/Common/CheckOutPage/CheckOutPage";
import {
  PrivacyPolicyPage,
  TermsAndConditionsPage,
} from "designs/Common/PolicyPage/PolicyPage";
import PayLaterPoliciesPage from "designs/Common/PayLaterPoliciesPage/PayLaterPoliciesPage";
import ReservedPage from "designs/Common/ReservedPage/ReservedPage";
import BookingDetailPage from "designs/Common/BookingDetailsPage/BookingDetailsPage";
import PaymentLinkRedirect from "designs/Common/PaymentLinkRedirect/PaymentLinkRedirect";
import PaymentSuccess from "designs/Common/PaymentSuccess/PaymentSuccess";
import TrackBookingPage from "designs/Common/TrackBooking/TrackBookingPage";
import PageAbout from "designs/DesignA/containers/PageAbout/PageAbout";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/home", component: PageHome },
  { path: "/available-car", component: AvailableCarsPage },
  { path: "/vehicles", component: ListingCarPage },
  { path: "/booking-details", component: BookingDetailPage },
  { path: "/payment-success", component: PaymentSuccess },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  { path: "/checkout", component: CheckOutPagePageMain },
  // 1NOW-10372: publicly linkable legal pages, reachable from the footer on
  // every page. /privacy-policy previously rendered the checkout modal's
  // PrivacyPolicy, which needs a `terms` prop the route never passed, so the
  // page came up empty.
  { path: "/privacy-policy", component: PrivacyPolicyPage },
  { path: "/terms-and-conditions", component: TermsAndConditionsPage },
  { path: "/contact", component: PageContact },
  { path: "/car-listing-detail", component: CarListingCarDetailPage },
  { path: "/about", component: PageAbout },
  { path: "/pay-later-policies", component: PayLaterPoliciesPage },
  { path: "/reserved", component: ReservedPage },
  { path: "/track-booking", component: TrackBookingPage },
];

const DesignARouter = () => {
  const { pathname } = useLocation();
  // Shared buttons (booking steps, Reserved, Track, the side menu's Book Now)
  // fill with Button Color on Design B and C, and with the Accent here, like
  // every other Design A button: `[.design-a_&]:` in their classes. On <html>,
  // not a wrapper, because the side menu and the phone sheets render in portals.
  useEffect(() => {
    document.documentElement.classList.add("design-a");
    return () => document.documentElement.classList.remove("design-a");
  }, []);
  return (
    <>
      <ScrollToTop />
      <ScrollToHash />
      <SiteHeader />
      {/* 1NOW-11153: the bar pinned to the top once the header has scrolled away, on every page
          that has the search. z-40: over the page, under the dialogs, sheets and menu (z-50). */}
      <PinnedHeader className="z-40 bg-bg-color text-base text-text-color dark:border-b dark:border-neutral-700">
        <MainNav pinned />
      </PinnedHeader>

      {/* 1NOW-1642: header and footer stay outside the boundary so a failed
          page still leaves the renter a way to navigate. */}
      <ErrorBoundary name="design-a-routes" resetKey={pathname}>
      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        {/* SMS payment short links: renter taps /pay/<slug>, we JS-redirect to Stripe/Square */}
        <Route path="/pay/:slug" element={<PaymentLinkRedirect />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      </ErrorBoundary>
      <div id="section-footer">
        <Footer />
      </div>
    </>
  );
};

export default DesignARouter;
